export function initSocialShareButtons() {
  const pageUrl = encodeURIComponent(window.location.href);
  const pageTitle = encodeURIComponent(document.title);

  const openPopup = (url) => {
    const w = 600,
      h = 400;
    const left = (screen.width - w) / 2;
    const top = (screen.height - h) / 2;
    window.open(
      url,
      '_blank',
      `width=${w},height=${h},top=${top},left=${left},resizable=yes`
    );
  };

  document
    .querySelector('.po-share-btn_twitter')
    ?.addEventListener('click', () => {
      openPopup(
        `https://twitter.com/intent/tweet?url=${pageUrl}&text=${pageTitle}`
      );
    });

  document
    .querySelector('.po-share-btn_facebook')
    ?.addEventListener('click', () => {
      openPopup(`https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`);
    });

  document
    .querySelector('.po-share-btn_linkedin')
    ?.addEventListener('click', () => {
      openPopup(
        `https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`
      );
    });

  document
    .querySelector('.po-share-btn_telegram')
    ?.addEventListener('click', () => {
      openPopup(`https://t.me/share/url?url=${pageUrl}&text=${pageTitle}`);
    });

  document
    .querySelector('.po-share-btn_email')
    ?.addEventListener('click', () => {
      window.location.href = `mailto:?subject=${pageTitle}&body=${pageUrl}`;
    });

  document
    .querySelector('.po-link-copy')
    ?.addEventListener('click', async (e) => {
      const svgUse = e.currentTarget.querySelector('use');
      if (!svgUse) return;

      const originalHref = svgUse.getAttribute('href');

      try {
        await navigator.clipboard.writeText(window.location.href);
        svgUse.setAttribute('href', '#svg-icons-share-check');

        setTimeout(() => {
          svgUse.setAttribute('href', originalHref);
        }, 2000);
      } catch (err) {
        console.error('Copy failed', err);
      }
    });
}
